import Vue from 'vue'
import Router from 'vue-router'
import pageContent from '@/pages/content/content.vue'
import pageContentDetails from '@/pages/content-details/content-details.vue'
import pageGroup from '@/pages/group/group.vue'
import pageHome from '@/pages/home/home.vue'
import pagePlanner from '@/pages/planner/planner.vue'
import pagePlayers from '@/pages/players/players.vue'
import pagePlayer from '@/pages/player/player.vue'
import pagePlayerEdit from '@/pages/player-edit/player-edit.vue'
import pagePlayerParty from '@/pages/player-party/player-party.vue'
import pageShop from '@/pages/shop/shop.vue'
import pageTeams from '@/pages/teams/teams.vue'
import pageTeam from '@/pages/team/team.vue'
import store from '@/store'

Vue.use(Router)

const routes = [
  {
    name: 'home',
    path: '/',
    component: pageHome
  },
  {
    name: 'homeRegister',
    path: '/register',
    component: pageHome
  },
  {
    name: 'homeTest',
    path: '/test1337',
    component: pageHome
  },
  {
    name: 'homeAuth',
    path: '/dc2023/:authToken',
    component: pageHome
  },
  {
    name: 'planner',
    path: '/planner',
    component: pagePlanner,
    meta: {
      dataRequired: ['matches', 'timelines']
    }
  },
  {
    name: 'players',
    path: '/players',
    component: pagePlayers,
    meta: {
      dataRequired: 'players'
    }
  },
  {
    name: 'teams',
    path: '/teams',
    component: pageTeams,
    meta: {
      dataRequired: 'teams'
    }
  },
  {
    name: 'shop',
    path: '/shop',
    component: pageShop,
    meta: {
      dataRequired: ['shopItems', 'shopOrders']
    }
  },
  {
    name: 'content',
    path: '/content',
    component: pageContent,
    meta: {
      dataRequired: 'content'
    }
  },
  {
    name: 'contentDetails',
    path: '/content/:contentId',
    component: pageContentDetails,
    meta: {
      dataRequired: 'content'
    }
  },
  {
    name: 'team',
    path: '/teams/:teamId',
    component: pageTeam,
    meta: {
      dataRequired: 'teams'
    }
  },
  {
    name: 'player',
    path: '/players/:playerId',
    component: pagePlayer,
    meta: {
      dataRequired: 'players'
    }
  },
  {
    name: 'player-achievements',
    path: '/players/:playerId',
    component: pagePlayer,
    meta: {
      tab: 1,
      dataRequired: 'players'
    }
  },
  {
    name: 'playerEdit',
    path: '/players/:playerId/edit',
    component: pagePlayerEdit,
    meta: {
      dataRequired: 'players'
    }
  },
  {
    name: 'playerParty',
    path: '/players/:playerId/party',
    component: pagePlayerParty,
    meta: {
      dataRequired: 'players'
    }
  },
  {
    name: 'group',
    path: '/planner/group/:groupId',
    component: pageGroup,
    meta: {
      dataRequired: 'groups'
    }
  }
]

const router = new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach(async (to, from, next) => {
  let p = Promise.resolve()

  if (store.state.authToken && store.state.lastLoadedDataTime === null) {
    p = store.dispatch('loadData', false)
  }

  p.then(() => {
    if (to && to.meta && to.meta.dataRequired && (!store.state.authToken ||
      (!(Array.isArray(to.meta.dataRequired) ? to.meta.dataRequired : [to.meta.dataRequired]).find(r => store.state[r] && Object.keys(store.state[r]).length)))) {
      next({ name: 'home' })
    } else {
      next()
    }
  })
})

router.afterEach(() => {
  if (store.state.authToken) {
    store.dispatch('loadData', false)
  }
})

export default router
